import React from 'react';
import { Text } from '@shopify/polaris';
import { resolveRefreshTargetDisplay, formatRefreshErrorSummary } from '../utils/refreshTargetStatus';

export default function RefreshTargetStatusPanel({ targetKey, context }) {
  const display = resolveRefreshTargetDisplay(targetKey, context);
  const errorSummary = display.errorText ? formatRefreshErrorSummary(display.errorText) : null;

  return (
    <div className="RefreshTargetStatusPanel">
      <span className={`RefreshTargetStatusPanel__pill RefreshTargetStatusPanel__pill--${display.phase}`}>
        {display.phaseLabel}
      </span>
      <Text as="p" variant="bodySm" tone="subdued" fontWeight="medium">
        {display.lastRunText}
      </Text>
      {display.summaryText && (
        <Text as="p" variant="bodySm" tone="subdued">
          {display.summaryText}
        </Text>
      )}
      {errorSummary && display.phase === 'error' && (
        <Text as="p" variant="bodySm" tone="critical">
          {errorSummary}
        </Text>
      )}
    </div>
  );
}
